import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { useMutation } from "@/modules/api/hooks/useMutation";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { changePasswordMutation } from "@/modules/auth/api/mutations/changePassword/changePasswordMutation";
import { notify } from "@/modules/notify/notify";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";

const translationNamespace = "apiMessages/useChangePasswordMutation";

export const useChangePasswordMutation = () => {
  const jsonApi = useJsonApi();
  const { t } = useTranslation(translationNamespace);
  const history = useHistory();
  return useMutation([changePasswordMutation.name], {
    mutationFn: changePasswordMutation(jsonApi),
    onSuccess: () => {
      notify.alert.success(t("Your password has been successfully updated!"));
      history.push(authenticatedRouting.buildUrl("more"));
    },
    onError: (error) => {
      apiErrorValidate(error, {
        401: {
          UNAUTHORIZED: t(
            "You are not allowed to change the password. Please try again"
          ),
        },
        403: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          INVALID_OLD_PASSWORD: t("You have entered an incorrect old password"),
        },
        404: {
          ACCOUNT_NOT_FOUND: t("Account cannot be found"),
        },
        422: {
          COMMON_PASSWORD: t(
            "Your new password is too easy to guess, please try another one"
          ),
        },
      });
    },
    retry: false,
  });
};
